import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

export const Container = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin: 10px;
`;

export const ButtonContainer = styled(Pressable)`
  justify-content: space-around;
  align-items: center;
  border-width: 2px;
  border-radius: 4px;
  border-color: navy;
  min-width: 80px;
  min-height: 80px;
  padding: 4px;
  ${props => props.notSelected && 'background-color: lightgray;'}
`;

export const Button = ({ option, handlePress, notSelected }) => {
  return (
    <ButtonContainer
      onPress={() => handlePress(option)}
      notSelected={notSelected}
    >
      <Text style={{ fontSize: 40 }}>
        {option.emoji || option.name[0]}
      </Text>
      <Text style={{ fontSize: 12 }}>
        {option.name}
      </Text>
    </ButtonContainer>
  );
};

const ButtonPicker = ({ value, setValue, options }) => {
  const handleOptionPress = option => {
    if (option.id === value) {
      setValue(null);
    } else {
      setValue(option.id)
    }
  };

  return (
    <Container>
      {options.map(option => (
        <Button
          key={option.id}
          option={option}
          handlePress={handleOptionPress}
          notSelected={value && value !== option.id}
        />
      ))}
    </Container>
  );
};

export default ButtonPicker;
